export const HeaderSection = {
  pools: 'Pools',
  colors: 'Colors',
  technology: 'Technology',
  accessories: 'Accessories',
  stages: 'Stages',
  order: 'Order',
  description: "Looking to add a touch of luxury to your home? Consider the benefits of an installed swimming pool. Residential swimming pools come in a variety of styles and sizes, making them a great option for any home. They can provide a fun and relaxing space for family and friends to gather, while also increasing the value of your property. Whether you're looking for a small, simple pool or a grand, elaborate one, an installed swimming pool can transform your backyard into a stunning oasis.",
};
